'use es6';

import { TABLE, PIE, DONUT, DATA_WELL } from 'reporting-data/constants/chartTypes';
import { isCustomWidgetReport, isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import ChartTypeToggleDropdown from 'report-customization-components/components/chart-type-toggle-dropdown/ChartTypeToggleDropdown';
import { isChartReport } from '../../../utils/salesAnalyticsHelpers';
import { SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const COLLECTION_EXCLUDED_CHART_TYPES = [TABLE, PIE, DONUT, DATA_WELL];
const ChartTypeControl = ({
  report,
  updateContext
}) => {
  return /*#__PURE__*/_jsx(ChartTypeToggleDropdown, {
    onChange: newReport => {
      const derivedChartType = newReport.get('chartType');
      updateContext({
        chartType: derivedChartType
      }, report);
    },
    report: report,
    excludedChartTypes: COLLECTION_EXCLUDED_CHART_TYPES
  });
};
ChartTypeControl.isUsableForReport = ({
  report,
  subAppKey
}) => {
  if (subAppKey === SUB_APPS.waterfall) {
    return false;
  }
  return isChartReport(report) && !isCustomWidgetReport(report) && !isRelationalReport(report);
};
export default ChartTypeControl;